import { achivement } from '../../utils/config.js'
import './achivement.style.css'

const Achivement = () => {
  return (
    <section id="portfolio">
      <h5>My Recent work</h5>
      <h2>Achivements</h2>

      <div className="container achivement_container">
        {achivement.map((a) => (
          <article className="achivement_item" key={a.name}>
            <div className="achivement_item_image">
              <img src={a.imagepath} alt={a.name} />
            </div>
            <h3>{a.name}</h3>
            <p style={{ marginTop: '2rem' }}>{a.desc}</p>

            <div className="btn_wrapper">
              <a href={a.imagepath} className="btn btn-primary" target="_blank">
                View
              </a>
            </div>
          </article>
        ))}
      </div>
    </section>
  )
}

export default Achivement
